import { handleActions } from 'redux-actions';
import { getReportActions, getReportActionsFailure, getReportActionsIdle, getReportActionsSuccess } from '../actions';

const status_get_report_actions = handleActions(
  {
    [getReportActions.toString()]: (state, action) => 'LOADING',
    [getReportActionsSuccess.toString()]: (state, action) => 'SUCCESS',
    [getReportActionsFailure.toString()]: (state, action) => 'FAILURE',
    [getReportActionsIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_report_actions = handleActions(
  {
    [getReportActions.toString()]: () => null,
    [getReportActionsSuccess.toString()]: (state, action) => action.payload,
  },
  null
);

export { status_get_report_actions, data_get_report_actions };
